import { PortalSettingsSidebar, PortalSettingsSidebarLink, PortalSettingsSidebarSection, PortalSettingsTheme, } from "@supernova-studio/model";
import { z } from "zod";
export const DTOPortalSettingsTheme = PortalSettingsTheme;
export const DTOPortalSettingsSidebarLink = PortalSettingsSidebarLink;
export const DTOPortalSettingsSidebarSection = PortalSettingsSidebarSection;
export const DTOPortalSettingsSidebar = PortalSettingsSidebar;
export const DTOPortalSettings = z.object({
    id: z.string(),
    workspaceId: z.string(),
    enabledDesignSystemIds: z.array(z.string()),
    enabledBrandPersistentIds: z.array(z.string()),
    theme: DTOPortalSettingsTheme.nullish(),
    sidebar: DTOPortalSettingsSidebar.nullish(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const DTOPortalSettingsGetResponse = z.object({
    portalSettings: DTOPortalSettings,
});
export const DTOPortalSettingsUpdatePayload = z.object({
    enabledDesignSystemIds: z.array(z.string()).optional(),
    enabledBrandPersistentIds: z.array(z.string()).optional(),
    theme: DTOPortalSettingsTheme.nullish(),
    sidebar: DTOPortalSettingsSidebar.nullish(),
});
